/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { isArray } from 'lodash';
import { mapGetters } from 'vuex';

// Components
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import ClosedCaptionsFormElement from 'shared/ui/components/form-components/ClosedCaptionsFormElement.vue';
import HtmlEditor from 'shared/ui/components/editors/html/HtmlEditor.vue';
import RadioButtons from 'shared/ui/components/form-components/RadioButtons.vue';
import SecondaryToolbar from 'shared/ui/components/form-components/SecondaryToolbar.vue';
import TargetingControl from 'shared/ui/components/form-components/TargetingControl.vue';
import ThumbnailPicker from 'shared/ui/components/form-components/ThumbnailPicker.vue';

// Mixins
import thumbnail from 'shared/ui/mixins/thumbnail';

const __vue_script__ = {
    name: 'MediaDetailsForm',

    components: {
        BaseInput,
        BaseSelect,
        ClosedCaptionsFormElement,
        HtmlEditor,
        RadioButtons,
        SecondaryToolbar,
        TargetingControl,
        ThumbnailPicker
    },

    mixins: [thumbnail],

    props: {
        details: {
            type: Object,
            default: () => {}
        },

        event: {
            type: Object,
            default: () => {}
        },

        showCategories: {
            type: Boolean,
            default: false
        },

        showTags: {
            type: Boolean,
            default: false
        },

        withTargeting: {
            type: Boolean,
            default: false
        }
    },

    data() {
        const isVideo = !this.details.type || this.details.type === 'mp4' || this.details.content_type === 'video/mp4';
        const tags = [...(this.details.tags || [])]
            .toSorted((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()));
        return {
            mounted: false,
            categories: [],
            currentCategories: [],
            mutable: {
                access_control: this.details.access_control,
                categories: [],
                description: isVideo ? this.details.description : undefined,
                has_thumbnail: this.details.has_thumbnail,
                tags,
                thumbnail: undefined,
                thumbnailSrc: '',
                title: this.details.title
            },
            thumbnailFlags: {
                removed: false,
                cropped: false
            },
            isVideo,
            saving: false
        };
    },

    computed: {
        ...mapGetters(['contentHub']),
        ...mapGetters('tags', ['tags']),

        /** @returns {boolean} */
        isDirty() {
            // @ts-ignore
            return this.mounted && this.$refs.form?.flags?.dirty;
        },

        hasCategoryChanged() {
            return this.currentCategories.some(category => !this.mutable.categories.includes(category)) ||
                this.mutable.categories.some(category => !this.currentCategories.includes(category));
        },

        /** @returns {boolean} */
        dataHasChanged() {
            return this.isDirty || this.thumbnailFlags.removed || this.thumbnailFlags.cropped || this.hasCategoryChanged;
        },

        showClosedCaptionsPicker() {
            return this.details.url?.includes('.m3u8');
        }
    },

    async created() {
        this.setThumbnailSrc();
        if (this.showCategories) {
            this.refreshCategories();
        }
    },

    mounted() {
        this.mounted = true;
    },

    methods: {
        async saveChanges() {
            try {
                if (this.saving) {
                    return;
                }
                this.saving = true;

                const targetData = {};
                if (this.mutable.access_control) {
                    targetData.access_control = this.mutable.access_control;
                }

                const title = this.mutable.title.trim();
                if (title !== this.details.title) {
                    targetData.title = title;
                }

                if (this.mutable.description !== this.details.description) {
                    targetData.description = this.mutable.description;
                }

                if (Object.keys(targetData).length) {
                    await this.detailsUpload(targetData);

                    if (targetData.title) {
                        this.$emit('titleChanged', targetData.title);
                    }
                }

                await this.saveCategories();

                if (this.thumbnailFlags.removed && !this.thumbnailFlags.cropped) {
                    const deleteResult = await this.thumbnailDeletion(this.details.eid, this.details.id);
                    if (deleteResult) {
                        this.mutable.has_thumbnail = false;
                    }
                }

                if (this.thumbnailFlags.cropped) {
                    const asset = this.mutable.thumbnail;
                    const uploadResult = await this.thumbnailUpload(asset, this.details.eid, this.details.id);
                    if (uploadResult) {
                        this.mutable.has_thumbnail = true;
                        this.setThumbnailSrc(true);
                    }
                }

                this.thumbnailFlags = {
                    removed: false,
                    cropped: false
                };

                this.$refs.form.reset();
            } catch (err) {
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('contents.messages.updated_error').toString(),
                    type: 'error',
                    duration: 5000
                });
            } finally {
                this.saving = false;
            }
        },

        async detailsUpload(targetData) {
            let result, message, messageType;
            try {
                result = await this.$services.content.updateContent(this.details.eid, this.details.id, targetData);
            } catch (err) {
                message = 'contents.messages.updated_error';
                messageType = 'error';
            }

            if (result) {
                message = 'contents.messages.updated';
                messageType = 'success';
                if (targetData.title !== undefined) {
                    this.mutable.title = targetData.title;
                }
            }

            if (message) {
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t(message).toString(),
                    type: messageType,
                    duration: 5000
                });
            }
        },

        croppedThumbnail(asset) {
            this.mutable.thumbnail = asset;
            // Need that to ensure the initial crop from setting the source doesn't count.
            if (isArray(asset) && asset[0].file && asset[0].file.size) {
                this.thumbnailFlags.cropped = true;
                this.mutable.has_thumbnail = true;
            }
        },

        deleteThumbnail() {
            this.thumbnailFlags.removed = true;
            this.mutable.has_thumbnail = false;

            this.setThumbnailSrc();
        },

        discardChanges() {
            this.$refs.form.reset();

            if (this.thumbnailFlags.removed || this.thumbnailFlags.cropped) {
                this.$refs.picker.removeFile();
            }

            this.mutable.has_thumbnail = this.details.has_thumbnail,
            this.mutable.title = this.details.title;

            this.setThumbnailSrc();

            if (this.details.has_thumbnail && (this.thumbnailFlags.removed || this.thumbnailFlags.cropped)) {
                this.$refs.picker.reinitPicker();
            }

            this.mutable.categories = this.currentCategories;

            this.thumbnailFlags = {
                removed: false,
                cropped: false
            };
        },

        setThumbnailSrc(withoutCache = false) {
            if (this.mutable.has_thumbnail) {
                this.mutable.thumbnailSrc = this.$services.content.getContentThumbnailUrl(this.details.eid, this.details.id, withoutCache);
                this.mutable.thumbnail = this.mutable.thumbnailSrc;
            } else {
                this.mutable.thumbnail = undefined;
                this.mutable.thumbnailSrc = '';
            }
        },

        async refreshTags() {
            await this.$store.dispatch('tags/refresh', {
                services: this.$services,
                contentHubId: this.details.eid
            });
        },

        /**
         * Whenever a tag is removed/added send a save request to BE
         */
        async tagChange() {
            let result, message, messageType;
            try {
                result = await this.$services.tags.updateTags(this.details.eid, this.details.id, this.mutable.tags);
            } catch (err) {
                message = 'contents.messages.tag_update_error';
                messageType = 'error';
            }

            if (result) {
                message = 'contents.messages.tag_update_success';
                messageType = 'success';
                this.mutable.tags = [...result];
                this.refreshTags();
            }

            if (message) {
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t(message).toString(),
                    type: messageType,
                    duration: 5000
                });
            }
        },

        /**
         * Creates a new tag and then save.
         */
        addTag(newTag) {
            this.mutable.tags.push({ value: newTag, label: newTag });
            this.tagChange();
        },

        async refreshCategories() {
            this.categories = await this.$services.category.getCategories(this.contentHub.id, false);
            this.currentCategories = this.categories.filter(category => category.contents.some(content => content.id === this.details.id));
            this.mutable.categories = this.currentCategories;
        },

        async saveCategories() {
            if (!this.hasCategoryChanged) {
                return;
            }
            for (const category of this.categories) {
                const currentIndex = this.currentCategories.indexOf(category);
                const mutedIndex = this.mutable.categories.indexOf(category);
                if (currentIndex !== mutedIndex && (currentIndex === -1 || mutedIndex === -1)) {
                    let content_ids = category.contents.map(content => content.id);
                    // Adding to category
                    if (currentIndex < 0 && mutedIndex >= 0) {
                        content_ids.unshift(this.details.id);
                    }
                    // Remove from category
                    if (mutedIndex < 0 && currentIndex >= 0) {
                        content_ids = content_ids.filter(contentId => contentId !== this.details.id);
                    }
                    await this.$services.category.editCategory(this.contentHub.id, category.id, {
                        content_ids
                    });
                }
            }
            this.refreshCategories();
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"form",attrs:{"slim":true},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
return [_c('form',{staticClass:"content-details-form",on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.saveChanges)}}},[_c('div',{staticClass:"grouped-controls"},[_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"title"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{attrs:{"errors":errors,"label":_vm.isVideo ? _vm.$t('contents.detail.title') : _vm.$t('contents.detail.document_title'),"name":"title","type":"text"},model:{value:(_vm.mutable.title),callback:function ($$v) {_vm.$set(_vm.mutable, "title", $$v)},expression:"mutable.title"}})]}}],null,true)}),_c('validation-provider',{attrs:{"slim":true,"name":"description"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [(_vm.isVideo)?_c('html-editor',{attrs:{"enable-custom-bstg-links":false,"errors":errors,"extras":false,"formats":false,"label":_vm.$t('contents.detail.description'),"links":true,"name":"description"},model:{value:(_vm.mutable.description),callback:function ($$v) {_vm.$set(_vm.mutable, "description", $$v)},expression:"mutable.description"}}):_vm._e()]}}],null,true)}),(_vm.showClosedCaptionsPicker)?_c('closed-captions-form-element',{attrs:{"event":_vm.event,"content-doc":_vm.details}},[_c('label',{staticClass:"control-label"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('contents.closed_captions.title')))])])]):_vm._e(),_c('validation-provider',{attrs:{"slim":true,"name":"access_control"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [(_vm.withTargeting)?_c('targeting-control',{attrs:{"dependant":false,"errors":errors,"event-id":_vm.event.id || _vm.event._id,"label":_vm.$t('contents.targeting.label'),"name":"access_control"},model:{value:(_vm.mutable.access_control),callback:function ($$v) {_vm.$set(_vm.mutable, "access_control", $$v)},expression:"mutable.access_control"}}):_vm._e()]}}],null,true)}),(_vm.showTags)?_c('base-select',{ref:"tags",attrs:{"hide-selected":true,"hint-after-label":true,"label":_vm.$t('contents.tags.label'),"multiple":true,"options":_vm.tags,"placeholder":_vm.$t('contents.tags.placeholder'),"taggable":true,"tip":_vm.$t('contents.tags.tip'),"name":"tags_picker","new-element-key":"contents.tags.newElt","track-by":"value"},on:{"input":_vm.tagChange,"tag":_vm.addTag},model:{value:(_vm.mutable.tags),callback:function ($$v) {_vm.$set(_vm.mutable, "tags", $$v)},expression:"mutable.tags"}}):_vm._e(),(_vm.showCategories)?_c('base-select',{ref:"categories",staticClass:"category-select",attrs:{"hide-selected":true,"hint-after-label":true,"label":_vm.$t('contents.categories.label'),"multiple":true,"options":_vm.categories,"placeholder":_vm.$t('contents.categories.placeholder'),"tip":_vm.$t('contents.categories.tip'),"name":"category_picker","options-label":"name","track-by":"id"},scopedSlots:_vm._u([{key:"after-label",fn:function(){return [_c('router-link',{attrs:{"to":{ name : 'media_categories' }}},[_vm._v(_vm._s(_vm.$t('contents.categories.create')))])]},proxy:true}],null,true),model:{value:(_vm.mutable.categories),callback:function ($$v) {_vm.$set(_vm.mutable, "categories", $$v)},expression:"mutable.categories"}}):_vm._e(),_c('thumbnail-picker',{ref:"picker",attrs:{"content":_vm.mutable},on:{"removed":_vm.deleteThumbnail,"done":_vm.croppedThumbnail}})],1),_c('secondary-toolbar',[_c('button',{staticClass:"btn",attrs:{"type":"button","disabled":!_vm.dataHasChanged},on:{"click":function($event){$event.preventDefault();return _vm.discardChanges.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('contents.detail.actions.discard')))]),_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.saving}},[_vm._v(_vm._s(_vm.$t('contents.detail.actions.save')))])])],1)]}}])})}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "MediaDetailsForm.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__